import React from 'react';
// import sections
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import FaleConosco from '../components/sections/FaleConosco';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import Hero from '../components/sections/Hero';

const Home = () => {

  return (
    <>
      <Header />
      <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FaleConosco />
      <Footer />
    </>
  );
}

export default Home;